import "./toggle.scss";
import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

export const Toggle = ({ label, available, item, category, size }) => {
  const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    withCredentials: true,
  });

  const [toggled, setToggled] = useState(available);
  const navigate = useNavigate();

  const handleAvailable = async () => {
    console.log(item);
    try {
      let newProduct;
      if (size === "small" || size === "medium" || size === "large") {
        if (size === "small") {
          newProduct = {
            ...item,
            isAvailableSmall: !toggled,
          };
        }
        if (size === "medium") {
          newProduct = {
            ...item,
            isAvailableMedium: !toggled,
          };
        }
        if (size === "large") {
          newProduct = {
            ...item,
            isAvailableLarge: !toggled,
          };
        }
        navigate(`/`);
      } else {
        newProduct = {
          ...item,
          isAvailable: !toggled,
        };
      }

      console.log(newProduct);
      setToggled(!toggled);
      await axiosInstance.put(`/${category}/${item._id}`, newProduct);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="toggleContainer">
      <label>
        <input
          type="checkbox"
          defaultChecked={toggled}
          onClick={() => handleAvailable()}
        />
        <span />
      </label>
      <h2>{label}</h2>
    </div>
  );
};
